export const alertsHeaders = [
  {
    text: "ID",
    value: "id",
    width: "100px"
  },
  {
    text: "Location Code",
    value: "facility.location_code",
    width: "100px"
  },
  {
    text: "District",
    value: "facility.district"
  },
  {
    text: "Note",
    value: "text"
  },
  {
    text: "Last Updated",
    value: "updated_at"
  },
  {
    text: "Expires At",
    value: "expires_at"
  },
  {
    text: "Actions...",
    sortable: false
  }
];
